import React, { useState, useEffect } from 'react';
import Card from '../components/common/Card';
import { toast } from 'react-toastify';
import api from '../services/api';

const PublicBooklets = () => {
  const [booklets, setBooklets] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBooklets();
  }, []);

  const fetchBooklets = async () => {
    setLoading(true);
    try {
      const response = await api.get('/booklets');
      setBooklets(response.data);
    } catch (error) {
      console.error('Error fetching booklets:', error);
      toast.error('Failed to fetch booklets');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (booklet) => {
    try {
      window.open(api.defaults.baseURL + `/booklets/download/${booklet.id}`, '_blank');
      toast.success('Download started');
    } catch (error) {
      console.error('Error downloading booklet:', error);
      toast.error('Failed to download booklet');
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return 'Unknown';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div style={{ backgroundColor: '#FEFBEC', minHeight: '100vh' }}>
      {/* Hero Section - Left Aligned with Gold Bottom Border - Reduced Height */}
      <div className="bg-white border-b-4 border-[#fbbf24] shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-lg sm:text-xl">📘</span>
            </div>
            <div>
              <h1 className="text-lg sm:text-xl font-bold text-gray-800 mb-0.5">
                Graduation Booklets
              </h1>
              <p className="text-xs sm:text-sm text-gray-600">
                Download graduation program booklets and ceremony guides
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          </div>
        ) : booklets.length === 0 ? (
          <Card className="text-center py-12">
            <div className="text-6xl mb-4">📘</div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">No Booklets Available</h3>
            <p className="text-gray-600">Check back later for graduation program booklets.</p>
          </Card>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
            {booklets.map((booklet) => (
              <Card key={booklet.id} className="hover:shadow-lg transition-all duration-300 p-4 flex flex-col h-auto">
                <div className="flex-1">
                  <div className="text-4xl mb-2">📄</div>
                  <h3 className="text-base font-semibold text-gray-800 mb-1 line-clamp-2">
                    {booklet.title}
                  </h3>
                  {booklet.graduation_year && (
                    <span className="inline-block px-2 py-0.5 bg-primary/10 text-primary rounded-full text-xs mb-2">
                      🎓 {booklet.graduation_year}
                    </span>
                  )}

                  {booklet.description && (
                    <p className="text-xs text-gray-600 mb-2 line-clamp-2">
                      {booklet.description}
                    </p>
                  )}

                  <div className="text-xs text-gray-500 space-y-0.5 mb-3">
                    <p className="truncate">📁 {booklet.file_name}</p>
                    <p>📊 {formatFileSize(booklet.file_size)}</p>
                    <p>📅 {new Date(booklet.created_at).toLocaleDateString()}</p>
                    <p>📥 {booklet.download_count || 0} downloads</p>
                  </div>
                </div>

                <button
                  onClick={() => handleDownload(booklet)}
                  className="inline-flex items-center justify-center w-full px-3 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors text-sm font-medium mt-2"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  Download Booklet
                </button>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicBooklets;
